import { createSelectionListViewContainer } from 'factories/SelectionListView'
import supplierActions from 'actions/suppliers'
import Component from 'components/Jobs/Labour/FormView/SelectOperator'

export default createSelectionListViewContainer({
  extraDispatchToProps: (dispatch, props) => ({
    getItems: (params = {}) => dispatch(supplierActions.getOptions({ active: 'Active', ...params })),
  }),
})(Component)
